import icons from '@nocode-works/template/icons'

export const API = '/api/v1'
export const BUILDER_API = (id) => `/builder/api/${id}`

export const RESPONSIVE_BREAKPOINT = 'md'

export const APP_TITLE = 'Nocode'

export const GOOGLE_LOGIN = '/api/v1/auth/google'
export const LOGOUT_URL = document.location.hostname == 'localhost' ? '/login' : 'https://nocode.works'
export const LOGIN_REDIRECT_URL = document.location.hostname == 'localhost' ? '' : `https://nocode.works`
export const STRIPE_PUBLIC_KEY = process.env.STRIPE_PUBLIC_KEY

export const DEV_MODE = process.env.NODE_ENV === 'development'

export const DEFAULT_CURRENCY = 'usd'
export const DEFAULT_PRODUCT = 'free'
export const CURRENCIES = [{
  id: 'usd',
  title: 'USD',
  symbol: '$',
},{
  id: 'gbp',
  title: 'GBP',
  symbol: '£',
},{
  id: 'eur',
  title: 'EUR',
  symbol: '€',
}]

/*

  {
    id: 'collaboration',
    title: 'Collaboration',
    description: `Allow multiple users to publish a website.`,
    type: 'tick',
  }, 

*/
export const PRODUCT_FEATURES = [{
  id: 'noadvert',
  title: 'Hide Nocode Advert',
  description: `Don't show a small advert for nocode with your published site`,
  type: 'tick',
}, {
  id: 'domain',
  title: 'Custom Domains',
  description: `Add your own domains to your website,`,
  type: 'tick',
}, {
  id: 'forms',
  title: 'Contact Forms',
  description: `Add contact forms to your website`,
  type: 'tick',
}, {
  id: 'search',
  title: 'Search',
  description: `Allow users to search your websites to find content.`,
  type: 'tick',
}, {
  id: 'passwords',
  title: 'Password Protection',
  description: `Publish private websites only accessible by certain people.`,
  type: 'tick',
}, {
  id: 'ecommerce',
  title: 'E-Commerce',
  description: `Use Stripe to Sell things on your website.`,
  type: 'tick',
}, {
  id: 'bandwidth',
  title: 'Bandwidth',
  description: `Bandwidth is used when visitors see your website - figure shown is per month.`,
  type: 'bytes',
}, {
  id: 'storage',
  title: 'Storage',
  description: `Storage is used each time you publish your website.`,
  type: 'bytes',
}]

export const MENU_ITEMS = {
  websites: () => ({
    title: 'Websites',
    link: 'website.list',
    icon: icons.website,
  }),
  templates: () => ({
    title: 'Templates',
    link: 'template.list',
    icon: icons.template,
  }),
  payments: () => ({
    title: 'Billing',
    link: 'account.payments',
    icon: icons.payments,
  }),
  accountSettings: () => ({
    title: 'Account Settings',
    link: 'account.settings',
    icon: icons.account,
  }),
  help: () => ({
    title: 'Get Help',
    link: 'help',
    icon: icons.help,
  }),
  guide: () => ({
    title: 'Nocode Guide',
    handler: () => {
      window.open('https://guide.nocode.works')
    },
    icon: icons.guide,
  }),
  login: () => ({
    title: 'Login',
    link: 'login',
    icon: icons.login,
  }),
  logout: (handlers) => ({
    title: 'Logout',
    handler: handlers.logout,
    icon: icons.logout,
  })
}

export const getSideMenu = ({
  loggedIn,
  user,
  handlers,
}) => {
  if(loggedIn) {
    return [
      MENU_ITEMS.websites(),
      MENU_ITEMS.payments(),
      user.tags && user.tags.admin ? MENU_ITEMS.templates() : null,
      user.tags && user.tags.admin ? MENU_ITEMS.accountSettings() : null,
      MENU_ITEMS.help(),
      MENU_ITEMS.guide(),
      MENU_ITEMS.logout(handlers)
    ].filter(item => item)
  }
  else {
    return [
      MENU_ITEMS.login(),
      MENU_ITEMS.help(),
      MENU_ITEMS.guide(),
    ]
  }
}

export const getAppbarMenu = ({
  loggedIn,
  user,
  handlers,
}) => {
  if(loggedIn) {
    return [
      MENU_ITEMS.websites(),
      MENU_ITEMS.payments(),
      user.tags && user.tags.admin ? MENU_ITEMS.templates() : null,
      user.tags && user.tags.admin ? MENU_ITEMS.accountSettings() : null,
      MENU_ITEMS.help(),
      MENU_ITEMS.guide(),
      MENU_ITEMS.logout(handlers)
    ].filter(item => item)
  }
  else {
    return [
      MENU_ITEMS.login(),
      MENU_ITEMS.help(),
      MENU_ITEMS.guide(),
    ]
  }
}

export const DRIVE_EXPERIENCE_LEVELS = [{
  title: 'Absolutely None',
  value: 'none',  
}, {
  title: 'I\'ve used it a bit',
  value: 'some',
}, {
  title: 'Boafide Superuser',
  value: 'lots',
}]

export const ONBOARDING_TEMPLATES = [{
  id: 'blog',
  title: 'Blog',
  description: 'A blog template where each post is a Google document',
  image: '/img/onboarding/blog.jpg',
}, {
  id: 'documentation',
  title: 'Documentation',
  description: 'Documentation website with nested folders of content',
  image: '/img/onboarding/documentation.jpg',
}, {
  id: 'portfolio',
  title: 'Portfolio',
  description: 'Perfect for showcasing your product or services',
  image: '/img/onboarding/portfolio.jpg',
}, {
  id: 'intranet',
  title: 'Intranet',
  description: 'Publish internal documents to team-members',
  image: '/img/onboarding/intranet.jpg',
}]